import React, { useEffect, useState } from "react";
import { BaseWizardProps } from "../wizard/wizard-step-base";
import { AppDispatch, RootState } from "../../state/store";
import { useDispatch, useSelector } from "react-redux";
import {
  defaultValidate,
  WizardButtonGroup,
} from "../wizard/wizard-button-group-component";
import {
  GoADivider,
  GoADropdown,
  GoADropdownItem,
  GoAFormItem,
  GoARadioGroup,
  GoARadioItem,
  GoASpacer,
} from "@abgov/react-components";
import { set } from "lodash";
import { updateCollision } from "../../state/slices/collisionSlice";
import {
  pushNotification,
  removeAllValidationErrorNotifications,
} from "../../state/slices/notificationSlice";
import { NotificationType } from "../notifications/notification-component";
import { Collision } from "../../models/collision";

interface ParkingLotComponentProps extends BaseWizardProps {}

const useAppDispatch = () => useDispatch<AppDispatch>();
const useAppSelector: <TSelected>(
  selector: (state: RootState) => TSelected
) => TSelected = useSelector;

export const ParkingLotomponent = ({
  navigationConfiguration,
}: ParkingLotComponentProps) => {
  const dispatch = useAppDispatch();

  const defaultSelection = "-1";

  const errorText = "Choose yes or no";
  const headerErrorText = "Make a selection below";

  const [formError, setFormError] = useState("");

  const stateCollision = useAppSelector((state: RootState) => state.collision);
  const stateConfiguration = useAppSelector(
    (state: RootState) => state.configuration
  );

  const [nextPage, setNextPage] = useState("");

  const [selection, setSelection] = useState(
    stateCollision.collision.parkingLot != undefined
      ? stateCollision.collision.parkingLot
        ? "1"
        : "0"
      : defaultSelection
  );

  useEffect(() => {
    let pageConfig;

    if (selection == "1") {
      pageConfig = navigationConfiguration.pagingConfiguration.find(
        (item) => item.yes !== undefined
      );

      setNextPage(pageConfig?.yes ?? "error");
    } else if (selection == "0") {
      pageConfig = navigationConfiguration.pagingConfiguration.find(
        (item) => item.no !== undefined
      );

      setNextPage(pageConfig?.no ?? "error");
    }
  }, [selection]);

  const getParkingLot = () => {
    if (selection == "1") {
      return true;
    } else if (selection == "0") {
      return false;
    }

    return undefined;
  };

  const validate = (): boolean => {
    const valid = defaultValidate(
      selection,
      defaultSelection,
      errorText,
      setFormError,
      navigationConfiguration.errorNotification
    );

    // we have a special case where we need to remove all validation errors first then display a different error
    if (!valid) {
      dispatch(removeAllValidationErrorNotifications());
      dispatch(
        pushNotification({
          body: headerErrorText,
          notificationType: NotificationType.importantValidationError,
        })
      );
    }

    return valid;
  };
  const save = () => {
    const parkingLotId =
      stateConfiguration.configuration.specialFacilities.find(
        (x) => x.value == "Parking Lot"
      )?.id;

    let updatedCollision: Collision = { ...stateCollision.collision };

    if (
      navigationConfiguration.updateMetadata &&
      navigationConfiguration.stepId
    ) {
      const stepUpdated = navigationConfiguration.updateMetadata(
        updatedCollision,
        navigationConfiguration.stepId!,
        navigationConfiguration.stageCompleted
          ? navigationConfiguration.stageCompleted
          : false,
        !navigationConfiguration.stageCompleted
      );

      if (stepUpdated && updatedCollision.metadata) {
        updatedCollision.metadata = {
          ...updatedCollision.metadata,
          formState: stepUpdated,
        };
      }
    }

    updatedCollision.parkingLot = getParkingLot();
    updatedCollision.specialFacility =
      selection == "1" ? parkingLotId : undefined;

    dispatch(updateCollision(updatedCollision));

    if (navigationConfiguration.save) {
      navigationConfiguration.save();
    }
  };

  return (
    <div>
      <h2>Road types</h2>
      <GoASpacer vSpacing={"l"} />
      Provide the required information below.
      <GoASpacer vSpacing={"l"} />
      <div className="large-body">
        Did your hit and run occur in a parking lot?
      </div>
      <GoASpacer vSpacing={"m"} />
      <GoAFormItem error={formError}>
        <GoARadioGroup
          name="parkingLotGroup"
          value={selection}
          error={formError.length > 0}
          onChange={(_, value) => {
            setFormError("");
            dispatch(removeAllValidationErrorNotifications());
            setSelection(value);
          }}
        >
          <GoARadioItem value={"1"} label="Yes" />
          <GoARadioItem value={"0"} label="No" />
        </GoARadioGroup>
      </GoAFormItem>
      <WizardButtonGroup
        nextPage={nextPage}
        goToReview={navigationConfiguration.goToReview}
        validate={validate}
        save={save}
        navigate={navigationConfiguration.navigate}
      />
    </div>
  );
};
